<script setup lang="ts">
import { watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import SideMenuInner from '@/dashboard/vue/components/layout/SideMenu/SideMenuInner.vue';
import { useLayoutStore } from '@/dashboard/store/layoutStore';

const route = useRoute();
const layoutStore = useLayoutStore();
const { isOpenMainMenu } = storeToRefs(layoutStore);

function closeSideMenu(): void {
  layoutStore.toggleOpenMainMenu(false);
}

watch(route, (newValue, oldValue) => {
  closeSideMenu();
});
</script>

<template>
  <div
    v-if="isOpenMainMenu"
    class="menu-backdrop fixed bottom-zero left-zero right-zero top-zero z-[10001] block bg-gray-250/60 dark:bg-black/60 laptop:hidden"
    @click="closeSideMenu"
  />
  <div
    class="flex h-full w-[241px] flex-row justify-end pb-s delay-150 ease-in-out max-tablet:fixed max-tablet:z-[100001] max-tablet:min-h-dscreen max-tablet:bg-white max-tablet:shadow-x max-tablet:transition-[left] dark:max-tablet:bg-black"
    :class="{ 'max-tablet:left-[-241px]': !isOpenMainMenu, 'max-tablet:left-zero': isOpenMainMenu }"
  >
    <SideMenuInner />
    <div class="divider-panel hidden w-[1px] laptop:flex" />
  </div>
</template>
